/**
 * The router-building helper, shared by `PlainConsole.tsx` (the demo path) and
 * `src/auth/RealConsole.tsx` (the e2e test-token path under a real base URL).
 *
 * `createElement`, not JSX, and that is why this is a `.ts` file rather than `.tsx`: a `.tsx`
 * that exports anything besides components loses Fast Refresh for the whole module, and this
 * function is not a component. `PlainConsole.tsx` is the JSX half.
 */
import { createElement, type ReactElement, type ReactNode } from 'react'
import { Outlet, createBrowserRouter } from 'react-router-dom'
import { buildRoutes } from './routes/index.ts'

export function buildRouter(chrome: (children: ReactNode) => ReactElement) {
  return createBrowserRouter([
    { element: chrome(createElement(Outlet)), children: buildRoutes() },
  ])
}
